import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'prototypes/securedCard/app.module.scss';
import { PrototypePath } from 'prototypes/securedCard/paths';

interface StepFooterProps {
  backTo?: PrototypePath;
  nextLabel: string;
  onNext: () => void;
  nextDisabled?: boolean;
}

const StepFooter = ({ backTo, nextLabel, onNext, nextDisabled }: StepFooterProps) => {
  const navigate = useNavigate();

  return (
    <div className={styles.footerActions}>
      <button type="button" className={styles.primaryButton} onClick={onNext} disabled={nextDisabled}>
        {nextLabel}
      </button>
      {backTo && (
        <button type="button" className={styles.quietButton} onClick={() => navigate(backTo)}>
          Back
        </button>
      )}
    </div>
  );
};

export default StepFooter;
